import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { I18nProvider } from "@/context/I18nContext";
import AppLayout from "@/components/AppLayout";
import Landing from "@/pages/Landing";
import QuoteGenerator from "@/pages/QuoteGenerator";
import InvoiceXmlPage from "@/pages/InvoiceXmlPage";
import Legal from "@/pages/Legal";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Benvenuto from "@/pages/Benvenuto";
import Dashboard from "@/pages/Dashboard";
import Clienti from "@/pages/Clienti";
import Documenti from "@/pages/Documenti";
import Solleciti from "@/pages/Solleciti";
import Ricorrenti from "@/pages/Ricorrenti";
import Report from "@/pages/Report";
import Abbonamento from "@/pages/Abbonamento";
import { PaymentCancel, PaymentSuccess } from "@/pages/PaymentResult";
import DocumentoEditor from "@/pages/DocumentoEditor";
import Agenda from "@/pages/Agenda";
import Memoria from "@/pages/Memoria";
import Impostazioni from "@/pages/Impostazioni";
import Lancio from "@/pages/Lancio";
import Admin from "@/pages/Admin";
import LeadFinder from "@/pages/LeadFinder";

const Loading = () => (
  <div className="flex h-screen items-center justify-center text-sm text-slate-500">
    Caricamento…
  </div>
);

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
};

const Guest = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return null;
  if (user) return <Navigate to={user.onboarded_at ? "/dashboard" : "/benvenuto"} replace />;
  return children;
};

const RootGate = () => {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (user === false) return <Landing />;
  return <Navigate to="/dashboard" replace />;
};

const AdminOnly = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (user === false) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
};

function App() {
  return (
    <BrowserRouter>
      <I18nProvider>
      <AuthProvider>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<RootGate />} />
          <Route path="/generatore-preventivi-gratis" element={<QuoteGenerator pageLang="it" />} />
          <Route path="/free-quote-generator" element={<QuoteGenerator pageLang="en" />} />
          <Route path="/fattura-elettronica-gratis" element={<InvoiceXmlPage />} />
          <Route path="/privacy" element={<Legal doc="privacy" />} />
          <Route path="/terms" element={<Legal doc="terms" />} />
          <Route path="/refund" element={<Legal doc="refund" />} />
          <Route path="/login" element={<Guest><Login /></Guest>} />
          <Route path="/registrati" element={<Guest><Register /></Guest>} />
          <Route path="/benvenuto" element={<Protected><Benvenuto /></Protected>} />
          <Route element={<Protected><AppLayout /></Protected>}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/clienti" element={<Clienti />} />
            <Route path="/preventivi" element={<Documenti type="quote" />} />
            <Route path="/fatture" element={<Documenti type="invoice" />} />
            <Route path="/ricorrenti" element={<Ricorrenti />} />
            <Route path="/solleciti" element={<Solleciti />} />
            <Route path="/report" element={<Report />} />
            <Route path="/abbonamento" element={<Abbonamento />} />
            <Route path="/documenti/nuovo" element={<DocumentoEditor />} />
            <Route path="/documenti/:id" element={<DocumentoEditor />} />
            <Route path="/agenda" element={<Agenda />} />
            <Route path="/memoria" element={<Memoria />} />
            <Route path="/impostazioni" element={<Impostazioni />} />
            <Route path="/lancio" element={<AdminOnly><Lancio /></AdminOnly>} />
            <Route path="/admin" element={<AdminOnly><Admin /></AdminOnly>} />
            <Route path="/lead-finder" element={<AdminOnly><LeadFinder /></AdminOnly>} />
          </Route>
          <Route path="/payment/success" element={<Protected><PaymentSuccess /></Protected>} />
          <Route path="/payment/cancel" element={<Protected><PaymentCancel /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
      </I18nProvider>
    </BrowserRouter>
  );
}

export default App;
